import React from 'react';

import ContactActionComponent from '@/core/components/DonationDetails/DonationActions/actions/ContactActionComponent';
import ConversationsActionComponent from '@/core/components/DonationDetails/DonationActions/actions/ConversationsActionComponent';
import FinishActionComponent from '@/core/components/DonationDetails/DonationActions/actions/FinishActionComponent';
import { SharePrimaryActionComponent } from '@/core/components/DonationDetails/DonationActions/actions/SharePrimaryActionComponent';
import UpdateActionComponent from '@/core/components/DonationDetails/DonationActions/actions/UpdateActionComponent';
import type { DonationAction } from '@/core/lib/new-architecture/domain/donation.domain';
import { DonationActionType } from '@/core/lib/new-architecture/domain/donation.domain';

interface DonationsPrimaryActionsProps {
  actions: DonationAction[];
}

const DonationsPrimaryActions: React.FC<DonationsPrimaryActionsProps> = ({ actions }) => {
  const renderActions = actions.reduce((acc, action) => {
    switch (action.action) {
      case DonationActionType.CONTACT:
        return [...acc, <ContactActionComponent key={action.action} action={action} />];

      case DonationActionType.CONVERSATIONS:
        return [...acc, <ConversationsActionComponent key={action.action} action={action} />];

      case DonationActionType.FINISH:
        return [...acc, <FinishActionComponent key={action.action} action={action} />];

      case DonationActionType.UPDATE:
        return [...acc, <UpdateActionComponent key={action.action} action={action} />];

      case DonationActionType.SHARE:
        return [...acc, <SharePrimaryActionComponent key={action.action} action={action} />];

      default:
        return acc;
    }
  }, [] as React.ReactElement[]);

  if (renderActions.length === 0) {
    return null;
  }

  return <section className="grid w-full gap-4 lg:grid-cols-2 lg:gap-7">{renderActions}</section>;
};

export default DonationsPrimaryActions;
